<h1 mat-dialog-title>زمان ویزیت رو انتخاب نمایید</h1>
<div mat-dialog-content>
  <div class="row">
    <div class="col-12" style="overflow: auto; min-width: 450px">
      <span>{{weekCount === 1 ? 'هفته جاری' : weekCount === 2 ? 'هفته بعد' : weekCount + ' هفته بعد'}}</span>
    </div>
    <br/>
    <div class="col-12">
      <app-table [list]="viewInfo" [translation]="translation" (clicked)="selectChanged($event)">
      </app-table>
    </div>
    <br/>
    <div class="col-12">
      <app-custom-button
        [Show]="true"
        [LabelText]="'هفته بعدی'"
        [backButtonLabel]="'هفته قبلی'"
        [BackButton]="weekCount > 1"
        (OnClick)="getWeek(weekCount + 1)"
        (OnGoBack)="getWeek(weekCount - 1)"
      ></app-custom-button>
    </div>
    <br/>
    <div class="col-12">
      <div *ngIf="visitType !== 'ON_DOOR' && selected">
        <app-select-field [fieldLabel]="'کلینیک'"
                          [fieldName]="'clinicID'"
                          [Group]="formGroup"
                          [translation]="translation"
                          [options]="selected.clinics">
        </app-select-field>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button [disabled]="!formGroup.valid" (click)="submit()" cdkFocusInitial>تایید
  </button>
  <button mat-button (click)="onNoClick()">بازگشن</button>
</div>
